if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cartNotification = document.querySelector('cart-notification')
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        const submitButton = this.querySelector('[type="submit"]')
        if (submitButton.classList.contains('loading')) return

        this.handleErrorMessage()
        this.cartNotification.setActiveElement(document.activeElement)

        submitButton.setAttribute('aria-disabled', true)
        submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden',
        )

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        formData.append(
          'sections',
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
        )
        formData.append('sections_url', window.location.pathname)
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description)
              return
            }

            if (
              $('.recommended-pro .recommended-pro-col input').is(':checked')
            ) {
              addRecomendedProducts() //multiple items add function
            } else if (
              $('.product__info-container .free-gift-banner').length > 0
            ) {
              addFreeGift()
            } else {
              if ($('body').hasClass('cart-drawer-enable')) {
              } else {
                this.cartNotification.renderContents(response) //cart-notification
              }
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            )
          })
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    },
  )
}

function addRecomendedProducts() {
  var data = []
  var checkboxs = $('.recommended-pro .recommended-pro-col input:checked')
  $(checkboxs).each(function () {
    var ids = $(this).attr('p-id')
    data.push({ add_data: 'id=' + ids + '&quantity=1' })
  })
  //console.log('data',data);
  addMutiplItem(data)
}

function addMutiplItem(array) {
  var arrLength = array.length
  if (array.length) {
    var request = array.shift()
    var tempData = request.add_data
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: tempData,
      dataType: 'json',
      success: function (e) {
        addMutiplItem(array)
        if (arrLength <= 1) {
          renderCart()
        }
      },
      error: function (e, t) {
        console.log('error-->', t)
        addMutiplItem(array)
      },
    }
    $.ajax(params)
  }
}

function renderCart() {
  var cartNotiItem = $('.cart-notification-wrapper #cart-notification-product')
  $.each(cartNotiItem, function (key, val) {
    $(this).remove()
  })
  $.getJSON('/cart.js', function (cartobj) {
    //console.log('cartobj--',cartobj);
    var html = ''
    $.each(cartobj.items, function (key, val) {
      html +=
        '<div id="cart-notification-product" class="cart-notification-product">'
      html +=
        '<img class="cart-notification-product__image" src="' +
        val.featured_image.url +
        '" alt="' +
        val.featured_image.alt +
        '" width="70" height="70" loading="lazy">'
      html +=
        '<div><h3 class="cart-notification-product__name h4">' +
        val.product_title +
        '</h3><dl></dl></div>'
      html += '</div>'
    })
    $(html).insertBefore(
      'cart-notification #cart-notification .cart-notification__links',
    )
    $('cart-notification #cart-notification .cart-notification__links a').html(
      'View my cart (' + cartobj.item_count + ')',
    )
    $('.header .header__icon--cart').append(
      '<div class="cart-count-bubble"><span aria-hidden="true">' +
        cartobj.item_count +
        '</span><span class="visually-hidden">' +
        cartobj.item_count +
        ' items</span></div>',
    )
  })
  if (!$('cart-notification #cart-notification').hasClass('animate')) {
    $('cart-notification #cart-notification').addClass('animate')
  }
  if (!$('cart-notification #cart-notification').hasClass('active')) {
    $('cart-notification #cart-notification').addClass('active')
  }
}

function addFreeGift() {
  if ($('.product__info-container .free-gift-banner').length > 0) {
    var freePdIds = $('.product__info-container .free-gift-banner').attr(
        'data-free-proid',
      ),
      freePdComparePrice = $('.product__info-container .free-gift-banner').attr(
        'data-free-proCompareAt',
      ),
      freeGiftID = $('.product__info-container .free-gift-banner').attr(
        'data-timestamp-id',
      )
  }
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: freePdIds,
      qunatity: 1,
      properties: {
        _compareAt: freePdComparePrice,
        _freeGiftId: freeGiftID,
        _recomendItem: '',
      },
    },
    dataType: 'json',
    success: function (e) {
      setTimeout(function () {
        renderCart()
      }, 250)
    },
    error: function (e, t) {
      console.log('error-->', t)
    },
  }
  $.ajax(params)
}
